import React, { useEffect, useState, useRef, useCallback } from 'react'
import styled from 'styled-components';
import { maxMobile, maxWidth, primaryColor, primaryFont, primaryHeadingColor, retina, scrollbar, SecondaryColorTwo, secondaryFont, wMBold, wMedium } from '../../../Utils/utilsStyle';
import AlertsSearch from '../../alerts/components/AlertsSearch';
import NewClusterWidget from './NewClusterWidget';
import { actions as companiesAction } from '../../../Slice/CompaniesSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectClusterCompanies, selectClusterCompaniesCount, selectClusterCompaniesEnded, selectClusterCompaniesLoading, selectCompanies, selectedSortingType } from '../../../Selector/CompaniesSelector';
import { Company } from '../../../Types/CompaniesTypes';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Checkbox } from 'antd';
import PeopleWidgetWithOutHolo from '../../common/components/PeopleWidgetWithOutHolo';
import { parseColorGradientMixture } from '../../../Utils/UtilityFunctions';
import { ACCOUNT_CLUSTER_LIMIT, CLUSTER_DETAIL_ROUTE } from '../../../Utils/Constants';
import { prefetchClusterDetailRoute } from '../../../Utils/routePrefetch';
import GlobalButton from '../../common/components/GlobalButton';
import DoubleCheckIcon from '../../common/assets/svgIcons/DoubleCheckIcon';
import AffinitySearchResultItemSkeleton from '../../common/skeleton/AffinitySearchResultItemSkeleton';
import SkeletonCustom from '../../common/skeleton/SkeletonCustom';
import { actions as clusterActions } from '../../../Slice/ClustersSlice';
import { selectAllClusterCompanies, selectClusterDrawerOpen, selectClusterId, selectCreationSuccess } from '../../../Selector/ClustersSelector';
import { useNavigate } from 'react-router-dom';

const Heading = styled.h3`
  font-family: ${secondaryFont};
  font-size: 32px;
  line-height: 44px;
  color: ${primaryHeadingColor};
  font-weight: ${wMBold};
  margin-bottom: 0px;
  display: inline-block;
  padding: 0px 33px 16px 33px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    font-size: 28px;
    line-height: 30px;
  }
  @media all and (max-width: ${maxMobile}){
    padding: 0px 16px;
    font-size: 20px;
    line-height: 22px;
    margin-bottom: 8px;
  }
`;

const ContentWrapper = styled.div`
.drawer-body {
    /* padding: 0px 33px; */
    display: flex;
    flex-direction: column;
    height : calc(100vh - 140px) ;
    .content-box {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      padding: 0px 33px;
      .search-div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        column-gap: 16px;
        margin-bottom: 16px;
        flex-shrink: 0;
        .search-box {
          width: 100%;
          .search-wrapper {
            .ant-input-affix-wrapper {
              height: 32px;
              .ant-input {
                max-width: 370px;
                &::placeholder {
                  color: #7E7E7E;
                  font-family: Roboto;
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: normal;
                  letter-spacing: -0.4px;
                }
              }
            }
            .cross-icon {
              top: 8px;
              right: 12px;
            }
          }
        }
        .share-btn {
          height: 30px;
          background: ${primaryColor};
          border: 1px solid ${primaryColor};
          border-radius: 22px;
          color: #FFF;
          font-family: ${primaryFont};
          font-size: 14px;
          font-weight: ${wMBold};
          line-height: 13px;
          letter-spacing: -0.4px;
          padding: 7px 13px;
        }
      }
      .company-count {
        color: ${SecondaryColorTwo};
        font-family: ${primaryFont};
        font-size: 18px;
        font-weight: ${wMedium};
        line-height: 20px;
        letter-spacing: -0.556px;
        margin-bottom: 16px;
      }
      .cluster-company-section {
        min-height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        #cluster-company-scrollable-div {
          flex: 1;
          min-height: 0;
          height: auto;
          overflow-y: auto;
          overflow-x: hidden;
          ${scrollbar};
          .infinite-for-company-section {
            .company-list {
              display: flex;
              flex-direction: column;
              row-gap: 10px;
              padding: 2px 14px 0px 0px;
              .company-item {
                padding: 15px 16px;
                border-radius: 10px;
                border: 1px solid #DADADA;
                background: #FFF;
                box-shadow: 0 0 17px -2px rgba(0, 0, 0, 0.12);
                &.selected {
                  border: 2px solid #1EC252;
                }
                .left-section {
                  display: flex;
                  align-items: center;
                  column-gap: 16px;
                  .ant-checkbox-wrapper {
                    width: auto;
                    margin-bottom: 0px;
                  }
                  .person-without-holo {
                    padding: 2px !important;
                  }
                  .company-name {
                    color: #000;
                    font-family: ${secondaryFont};
                    font-size: 20px;
                    font-weight: ${wMedium};
                    line-height: 24px;
                    letter-spacing: -0.417px;
                  }
                }
              }
              .skeleton {
                display: flex;
                flex-direction: column;
                row-gap: 10px;
                .box {
                  display: flex;
                  align-items: center;
                  column-gap: 12px;
                  padding: 14px 16px;
                  border-radius: 10px;
                  border: 1px solid #DADADA;
                  background: #FFF;
                  box-shadow: 0 0 17px -2px rgba(0, 0, 0, 0.12);
                }
              }
            }
          }
        }
      }
    }
    .footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 80px;
      background: #FFF;
      box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.14);
      padding: 0px 24px;
      .selected-count {
        display: flex;
        flex-direction: column;
        .count-section {
          display: flex;
          align-items: center;
          column-gap: 8px;
          .icon {
            width: 22px;
          }
          .text {
            color: ${primaryColor};
            font-family: ${primaryFont};
            font-size: 18px;
            font-weight: ${wMedium};
            line-height: normal;
          }
        }
        .limit-section {
          color: #6A6A6A;
          font-family: Roboto;
          font-size: 12px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          margin-left: 31px;
          margin-top: -5px;
          max-width: 250px;
        }
        
      }
      .buttons-div {
        display: flex;
        align-items: center;
        column-gap: 8px;
      }
    }
  }
`;
type Props = {
  visible: boolean;
  isAddDrawer?: boolean
}

const defaultProps = {
  visible: false,
  isAddDrawer: false,
}
const CreateNewClusterSection = function CreateNewClusterSection(props: Props) {
  const { visible, isAddDrawer } = props
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCompanies, setSelectedCompanies] = useState<number[]>([]);
  const fetchingRef = useRef(false);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const paginationRef = useRef({
    loading: false,
    companiesLength: 0,
    companiesCount: 0,
    companiesEnded: false,
  });
  const loading = useSelector(selectClusterCompaniesLoading);
  const companiesEnded = useSelector(selectClusterCompaniesEnded);
  const sortingType = useSelector(selectedSortingType);
  const companies: Company[] = useSelector(selectClusterCompanies);
  const companiesCount: number = useSelector(selectClusterCompaniesCount);
  const [clusterName, setClusterName] = useState<string>('');
  const clusterDrawerOpen = useSelector(selectClusterDrawerOpen);
  const clusterCompanies: Company[] = useSelector(selectAllClusterCompanies);
  const clusterId = useSelector(selectClusterId);
  const clusterCreationSuccess = useSelector(selectCreationSuccess);
  const hasMoreCompanies = companies.length < companiesCount && !companiesEnded;

  paginationRef.current = {
    loading,
    companiesLength: companies.length,
    companiesCount,
    companiesEnded,
  };

  const tryLoadMore = useCallback(() => {
    const {
      loading: isLoading,
      companiesLength,
      companiesCount: total,
      companiesEnded: ended,
    } = paginationRef.current;

    if (fetchingRef.current || isLoading || ended || companiesLength >= total) {
      return;
    }

    fetchingRef.current = true;
    dispatch(companiesAction.getCompanies({
      offset: companiesLength,
      sortingType: sortingType || 'dateFollowed:desc',
      ...(searchTerm && { searchTerm }),
      myAccounts: true,
      mode: 'accountClusters',
    }));
  }, [dispatch, searchTerm, sortingType]);

  const handleScroll = useCallback(() => {
    const target = scrollContainerRef.current;
    if (!target) return;

    const { scrollTop, scrollHeight, clientHeight } = target;
    const isNearBottom = scrollTop + clientHeight >= scrollHeight - 50;

    if (isNearBottom) {
      tryLoadMore();
    }
  }, [tryLoadMore]);

  useEffect(() => {
    if (clusterCompanies.length > 0 && isAddDrawer) {
      setSelectedCompanies(
        clusterCompanies.map((company) => company.companyId)
      );
    }
  }, [clusterCompanies, isAddDrawer]);

  useEffect(() => {
    if (!visible) return;
    dispatch(companiesAction.getCompanies({
      offset: 0,
      searchTerm,
      sortingType: sortingType || 'dateFollowed:desc',
      myAccounts: true,
      mode: "accountClusters",
    }));
  }, [searchTerm, visible, sortingType, dispatch]);

  useEffect(() => {
    if (clusterCreationSuccess) {
      if (clusterId) {
        prefetchClusterDetailRoute(clusterId);
        navigate(`${CLUSTER_DETAIL_ROUTE}${clusterId}`);
      }
      dispatch(clusterActions.setDrawerOpen(false));
    }
  }, [clusterCreationSuccess])

  const fetchMore = tryLoadMore;

  useEffect(() => {
    if (!loading) {
      fetchingRef.current = false;
    }
  }, [loading]);

  useEffect(() => {
    const target = scrollContainerRef.current;
    if (!target || !visible) return undefined;

    target.addEventListener('scroll', handleScroll, { passive: true });
    return () => target.removeEventListener('scroll', handleScroll);
  }, [visible, handleScroll]);

  useEffect(() => {
    if (!visible || loading || !hasMoreCompanies) return;

    const target = scrollContainerRef.current;
    if (!target) return;

    const canFitMore = target.scrollHeight <= target.clientHeight + 10;
    if (canFitMore) {
      tryLoadMore();
    }
  }, [visible, loading, hasMoreCompanies, companies.length, tryLoadMore]);

  const onSearching = (value: string) => {
    setSearchTerm(value);
  };

  const handleCompanySelect = (companyId: number) => {
    setSelectedCompanies((prev) => {
      if (prev.includes(companyId)) {
        return prev.filter((id) => id !== companyId);
      }
      if (isAddDrawer) {
        const exisitingCompanyCount = clusterCompanies.length;
        if (prev.length >= ACCOUNT_CLUSTER_LIMIT) {
          return prev;
        }
        return [...prev, companyId];
      }
      if (prev.length >= 4) {
        return prev;
      }
      return [...prev, companyId];
    });
  };

  const createHandler = () => {
    const companyString = selectedCompanies.join(',');
    dispatch(clusterActions.manageAccountCluster({
      type: 'create',
      clusterName: clusterName,
      companyIds: companyString,
    }))
  }
  const addCompaniesHandler = () => {
    const addedCompanyIds = selectedCompanies.filter(
      (companyId) =>
        !clusterCompanies.some(
          (company) => companyId === company.companyId
        )
    );
    dispatch(clusterActions.manageAccountCluster({
      type: "edit",
      clusterId: clusterId,
      addedCompanyIds: addedCompanyIds.join(','),
    }))
    dispatch(clusterActions.setDrawerOpen(false));
  }

  const cancelHandler = () => {
    if (isAddDrawer) {
      setSelectedCompanies(
        clusterCompanies.map((company) => company.companyId)
      );
    } else {
      setSelectedCompanies([]);
    }
  }

  return (
    <ContentWrapper>
      <div className="drawer-header">
        <Heading>Account Browser</Heading>
      </div>
      <div className="drawer-body">
        <div className='content-box'>
          {
            !isAddDrawer && (
              <NewClusterWidget
                setClusterName={setClusterName}
              />
            )
          }
          <div className="search-div">
            <div className="search-box">
              <AlertsSearch
                placeholderText="Search your Account..."
                query={searchTerm}
                // loading={loading}
                onSearching={onSearching}
                margin="0px"
                height="30px"
              />
            </div>
          </div>
          <div className='company-count'>My Accounts {`(${companiesCount})`}</div>
          <div className='cluster-company-section'>
            <div
              id="cluster-company-scrollable-div"
              ref={scrollContainerRef}
            >
              <InfiniteScroll
                key={`cluster-companies-${visible ? 'open' : 'closed'}-${searchTerm}`}
                dataLength={companies.length}
                next={fetchMore}
                hasMore={hasMoreCompanies}
                loader={false}
                className="o-x-hidden infinite-for-company-section"
                scrollableTarget="cluster-company-scrollable-div"
              >
                <div className="company-list">
                  {
                    companies.length > 0 &&
                    companies.map((company) => {
                      const isAlreadyInCluster = isAddDrawer && clusterCompanies.some((item) => item.companyId === company.companyId);
                      const isSelected = selectedCompanies.includes(company.companyId);
                      return (
                        <div
                          key={company.companyId}
                          className={`company-item ${isSelected ? 'selected' : ''}`}
                          onClick={() => {
                            if (isAddDrawer && isAlreadyInCluster) {
                              return;
                            }
                            handleCompanySelect(company.companyId)
                          }}
                          role="button"
                        >
                          <div className="left-section">
                            <Checkbox
                              checked={isSelected}
                              // onChange={() => handleCompanySelect(company.companyId)}
                              disabled={(isAddDrawer && isAlreadyInCluster) || (selectedCompanies.length === 4 && !isSelected)}
                            />
                            <PeopleWidgetWithOutHolo
                              key={company?.companyId}
                              diameter="54px"
                              diameterSm="54px"
                              diameterXsm='40px'
                              marginSm="0px 3px 0px 3px"
                              margin='0'
                              wrapperColor={parseColorGradientMixture(company?.companyPersonality)}
                              logo={company?.companyLogo}
                              companyId={String(company.companyId) !== '' ? company.companyId : 0}
                              personForHover
                              personName={company.companyName}
                            />
                            <div className='company-name'>{company.companyName}</div>
                          </div>

                        </div>
                      )
                    })
                  }
                  {
                    loading && (
                      <div className="skeleton">
                        {[1, 2, 3, 4, 5, 6].map(() => (
                          <div className='box'>
                            <SkeletonCustom width="40px" height="40px" diameter="50%" margin="0px" />
                            <SkeletonCustom width="240px" height="20px" margin="0px" />
                          </div>
                        ))}
                      </div>
                    )
                  }
                </div>

              </InfiniteScroll>
            </div>
          </div>
        </div>
        <div className='footer'>
          <div className='selected-count'>
            <div className='count-section'>
              <div className='icon'><DoubleCheckIcon /></div>
              <span className='text'>Account selected {`(${selectedCompanies.length}/${ACCOUNT_CLUSTER_LIMIT})`}</span>
            </div>
            {
              selectedCompanies.length === ACCOUNT_CLUSTER_LIMIT && (
                <div className='limit-section'>
                  Account limit reached.{" "}
                  {
                    isAddDrawer && (
                      <span>Remove an account to add a new one</span>
                    )
                  }
                </div>
              )
            }
          </div>
          <div className='buttons-div'>
            <GlobalButton
              title='Cancel'
              outlineColor={primaryColor}
              textColor={primaryColor}
              innerSpace='9px 21px'
              bgColor='#fff'
              height='36px'
              borderRadius='18px'
              buttonClassName='cancel-btn'
              onButtonClick={cancelHandler}
            />
            {
              isAddDrawer ? (
                <GlobalButton
                  title='Add'
                  outlineColor={primaryColor}
                  textColor='#fff'
                  innerSpace='9px 21px'
                  bgColor={primaryColor}
                  height='36px'
                  borderRadius='18px'
                  buttonClassName='create-btn'
                  disabled={selectedCompanies.length === 0}
                  onButtonClick={addCompaniesHandler}
                />
              ) : (
                <GlobalButton
                  title='Create'
                  outlineColor={primaryColor}
                  textColor='#fff'
                  innerSpace='9px 21px'
                  bgColor={primaryColor}
                  height='36px'
                  borderRadius='18px'
                  buttonClassName='create-btn'
                  disabled={(clusterName.trim().length === 0 || selectedCompanies.length === 0)}
                  onButtonClick={createHandler}
                />
              )
            }
            {/* <GlobalButton
              title='Create'
              outlineColor={primaryColor}
              textColor='#fff'
              innerSpace='9px 21px'
              bgColor={primaryColor}
              height='36px'
              borderRadius='18px'
              buttonClassName='create-btn'
              disabled={(clusterName.trim().length === 0 || selectedCompanies.length === 0)}
              onButtonClick={createHandler}
            /> */}
          </div>
        </div>
      </div>
    </ContentWrapper>
  );
};
CreateNewClusterSection.defaultProps = defaultProps;
export default CreateNewClusterSection;
